<template>
  <div>
    <a-card title="微语录">
      <div slot="extra">
        <a-button type="danger" :disabled="!hasSelected" @click="handleDel">删除</a-button> &nbsp;&nbsp;
        <a-button type="primary" @click="showModal">新增</a-button>
        <!-- 异步提交的model对话框 -->
        <a-modal
          :visible="visible"
          title="新增"
          @ok="handleOk"
          :confirmLoading="confirmLoading"
          @cancel="handleCancel"
          width="600px"
        >
          <a-form :form="form">
            <a-form-item label="">
              <a-textarea
                placeholder="请输入文字，多条输入每一条，另起一行"
                :autosize="{ minRows: 10 }"
                v-decorator="['content', {rules: [{ required: true, message: '请输入语录' }]}]"/>
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
      <a-table
        :columns="columns"
        :dataSource="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="id"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        bordered>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getQuotationsList, addQuotations, delQuotations } from '@/api/manage'

const data = []
const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id',
  width: '2%'
}, {
  title: '内容',
  dataIndex: 'content',
  key: 'content'
}]
export default {
  data () {
    return {
      data,
      columns,
      // 添加微语录控制model
      visible: false,
      confirmLoading: false,
      // 选中的checkBox数组 key 值的集合
      selectedRowKeys: [],
      form: this.$form.createForm(this),
      loading: false,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      }
    }
  },
  // 微语录删除选中计算
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    }
  },
  mounted () {
    this.handleInitList({ page: 1, pageSize: 10 })
  },
  // 添加微语录
  methods: {
    handleInitList (params = {}) {
      this.loading = true
      return getQuotationsList(params)
        .then(res => {
          this.loading = false
          this.data = res.result.list
          this.pagination.total = res.result.total
        }).catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    showModal () {
      this.visible = true
    },
    handleOk (e) {
      this.confirmLoading = true
      console.log(this.form)
      this.form.validateFields((errors, values) => {
        if (!errors) {
          // const params = values.content.replace(/(\r\n|\n|\r)/gm, '\r\n')
          // console.log(params)
          addQuotations(values).then((res) => {
            this.visible = false
            this.confirmLoading = false
            this.$message.success(res.msg)
            this.handleInitList({ page: 1, pageSize: 10 })
          })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.visible = false
              this.confirmLoading = false
            })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.visible = false
    },
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed1: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleDel () {
      this.$confirm({
        title: '你确定要删除吗？',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.loading = true
          return delQuotations({ ids: this.selectedRowKeys })
            .then(res => {
              this.loading = false
              this.$message.success(res.msg)
              this.handleInitList({ page: 1, pageSize: 10 })
              this.selectedRowKeys = []
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.selectedRowKeys = []
              this.loading = false
            })
        },
        onCancel: () => {
          console.log('Cancel')
        }
      })
    },
    requestFailed (err) {
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.handleInitList({
        pageSize: pagination.pageSize,
        page: pagination.current,
        ...filters
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .text-area {
    resize: none;
  }
</style>
